module.exports = __webpack_public_path__ + "static/cf-med-61b92259c013640ca313c0bfed425994.ttf";